import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** One reason for visiting, and the info page (or chooser) it opens. */
export interface PermitTypeChoice {
    icon: string;
    label: string;
    /** Where the card goes: the permit type's info page, or the recreation split screen. */
    route: string;
}

/**
 * "What are you visiting for?" - the first choice in the application journey.
 *
 * One component because this is one question. It used to exist twice: as icon cards
 * on the home page and again as a plain list of buttons on the finder's first step,
 * so which version an applicant saw depended on whether they came via the home page
 * or the nav. Same seven options, two definitions that nothing kept in step, and the
 * nav route showed the worse of the two.
 */
@Component({
    selector: 'app-permit-type-chooser',
    templateUrl: './permit-type-chooser.component.html',
    styleUrls: ['./permit-type-chooser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PermitTypeChooserComponent {
    /** Rendered above the grid; omit where the page heading already asks the question. */
    @Input() heading?: string;

    /** The cards to show. Defaults to the full permit-type set; the recreation split passes its own. */
    @Input() public choices: PermitTypeChoice[] = [
        { icon: 'fa-umbrella-beach', label: 'Tourism', route: '/tourist-permit' },
        { icon: 'fa-campground', label: 'Recreation - camping, day-use or boat access', route: '/apply/recreation-choose' },
        { icon: 'fa-people-group', label: 'Visiting friends or family', route: '/friends-and-family' },
        { icon: 'fa-briefcase', label: 'Work', route: '/work-permit' },
        { icon: 'fa-camera', label: 'Media', route: '/media-permit' },
        { icon: 'fa-flask', label: 'Research', route: '/research-permit' },
        { icon: 'fa-fish', label: 'Fishing', route: '/fishing' },
        { icon: 'fa-crosshairs', label: 'Hunting', route: '/hunting' },
    ];
}
